import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Impressum() {
    return (
        <div className="relative min-h-screen overflow-hidden bg-black" data-testid="impressum-page">
            <div className="grain-overlay" />
            <div className="pointer-events-none absolute -top-40 -right-40 h-[400px] w-[400px] rounded-full bg-[#FF5A00]/10 blur-[120px]" />

            <nav className="relative z-10 px-6 py-6 sm:px-10">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-white/60 transition hover:text-[#FF5A00]"
                    data-testid="back-to-home"
                >
                    <ArrowLeft size={14} />
                    zurück
                </Link>
            </nav>

            <div className="relative z-10 mx-auto max-w-3xl px-6 pb-24 pt-4 sm:px-10">
                <h1 className="font-display text-4xl font-black tracking-tight text-white sm:text-5xl">
                    Impressum
                </h1>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                    Legal Notice / Anbieterkennzeichnung
                </p>

                <div className="mt-12 space-y-10 text-sm leading-relaxed text-white/70 sm:text-base">
                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            Anbieter / Betreiber
                        </h2>
                        <div className="space-y-1">
                            <p>Kylie West</p>
                            <p className="text-white/50">[Straße und Hausnummer]</p>
                            <p className="text-white/50">[PLZ Ort]</p>
                            <p className="text-white/50">United States</p>
                        </div>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            Kontakt
                        </h2>
                        <div className="space-y-1">
                            <p>
                                Email:{" "}
                                <a
                                    href="mailto:business@kyliewest.us"
                                    className="text-[#FF5A00] underline-offset-4 hover:underline"
                                >
                                    business@kyliewest.us
                                </a>
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            Verantwortlich für den Inhalt
                        </h2>
                        <p>Kylie West (Anschrift wie oben)</p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            Haftungsausschluss
                        </h2>
                        <p>
                            Die Inhalte dieser Seite werden mit größter Sorgfalt erstellt. Für die
                            Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch
                            keine Gewähr übernommen werden. Externe Links wurden zum Zeitpunkt
                            der Verlinkung geprüft — auf den Inhalt verlinkter externer Seiten
                            haben wir keinen Einfluss.
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            Urheberrecht
                        </h2>
                        <p>
                            Alle auf dieser Seite veröffentlichten Inhalte (Bilder, Texte, Grafiken)
                            unterliegen dem Urheberrecht. Eine Vervielfältigung oder Verwendung
                            ohne ausdrückliche Zustimmung von Kylie West ist nicht gestattet.
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            Altersbeschränkung
                        </h2>
                        <p>
                            Diese Webseite richtet sich ausschließlich an volljährige Personen
                            (18+). Mit dem Aufruf bestätigst du, dass du das gesetzlich
                            vorgeschriebene Mindestalter erreicht hast.
                        </p>
                    </section>
                </div>

                <p className="mt-16 font-mono text-[10px] uppercase tracking-[0.25em] text-white/30">
                    Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
                </p>
            </div>
        </div>
    );
}
